import React, { useState } from "react";
import { Tab, TabList, TabPanel, Tabs as Abas } from "react-tabs";
import styled from "styled-components";
import TabEmpresa from "./TabEmpresa";

function Tabs({
  touched,
  values,
  errors,
  handleChange,
  initValues,
  setFieldValue,
  formik,
  onTestConnect,
  onTestConnectHana,
  connected,
  connectedHana,
  isLoading,
  isLoadingHana
}) {
  const [tabIndex, setTabIndex] = useState(0);
  // const { initViceri, initCompra } = initValues;
  return (
    <ModernContainer>
      <Abas selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <ModernTabList>
          <ModernTab>Empresa</ModernTab>
          {/* <ModernTab>Compra</ModernTab>
          <ModernTab>Viceri</ModernTab>
          <ModernTab>Logo</ModernTab> */}
        </ModernTabList>
        <ModernTabPanel>
          <TabEmpresa
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            onTestConnect={onTestConnect}
            onTestConnectHana={onTestConnectHana}
            connected={connected}
            connectedHana={connectedHana}
            isLoading={isLoading}
            isLoadingHana={isLoadingHana}
          />
        </ModernTabPanel>
        {/* <ModernTabPanel>
          <TabCompra
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            initialValues={initCompra}
          />
        </ModernTabPanel>
        <ModernTabPanel>
        <TabViceri
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            initialValues={initViceri}
          />
        </ModernTabPanel>
        <ModernTabPanel>
          <TabLogo
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
          />
        </ModernTabPanel> */}
      </Abas>
    </ModernContainer>
  );
}

const ModernContainer = styled.div`
  width: 100%;
  font-family: 'Mulish', sans-serif;

  .react-tabs {
    -webkit-tap-highlight-color: transparent;
  }

  .react-tabs__tab-list {
    border-bottom: 2px solid #e2e8f0 !important;
    margin: 0 0 24px !important;
    padding: 0 !important;
    display: flex !important;
    gap: 8px !important;
    flex-wrap: wrap !important;
  }

  .react-tabs__tab {
    padding: 12px 24px !important;
    border: none !important;
    background: transparent !important;
    cursor: pointer !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #64748b !important;
    border-bottom: 3px solid transparent !important;
    transition: all 0.3s ease !important;
    font-family: 'Mulish', sans-serif !important;
    outline: none !important;
    list-style: none !important;
    position: relative !important;
    margin: 0 !important;

    &:hover {
      color: #667eea !important;
      background: rgba(102, 126, 234, 0.05) !important;
      border-radius: 8px 8px 0 0 !important;
    }
  }

  .react-tabs__tab--selected {
    color: #667eea !important;
    border-bottom-color: #667eea !important;
    background: rgba(102, 126, 234, 0.05) !important;
    border-radius: 8px 8px 0 0 !important;
  }

  .react-tabs__tab--disabled {
    color: #cbd5e1 !important;
    cursor: not-allowed !important;

    &:hover {
      color: #cbd5e1 !important;
      background: transparent !important;
    }
  }

  .react-tabs__tab:focus {
    box-shadow: none !important;
  }

  .react-tabs__tab-panel {
    display: none !important;
    animation: fadeIn 0.3s ease !important;
  }

  .react-tabs__tab-panel--selected {
    display: block !important;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const ModernTabList = styled(TabList)``;

const ModernTab = styled(Tab)``;

const ModernTabPanel = styled(TabPanel)``;

export default Tabs;
